import { render, staticRenderFns } from "./AppRecover.vue?vue&type=template&id=643ab196&scoped=true"
import script from "./AppRecover.vue?vue&type=script&lang=js"
export * from "./AppRecover.vue?vue&type=script&lang=js"
import style0 from "./AppRecover.vue?vue&type=style&index=0&id=643ab196&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643ab196",
  null
  
)

export default component.exports